// ABOUTME: The Approvals page's data: approvals as GET /agent/approvals returns them (snake_case),
// grouped by the backend's group_key (same caller, action and video or picture), and times
// said in plain words in the business's own timezone.
import type { AgentApprovalResponse } from '@/types'

export interface ApprovalGroup {
  key: string
  items: AgentApprovalResponse[]
}

/** Approvals sharing a group_key become one group, in the order their first card arrived. */
export function groupApprovals(approvals: AgentApprovalResponse[]): ApprovalGroup[] {
  const groups = new Map<string, AgentApprovalResponse[]>()
  for (const a of approvals) {
    const key = a.group_key ?? a.id
    const items = groups.get(key)
    if (items) items.push(a)
    else groups.set(key, [a])
  }
  return [...groups].map(([key, items]) => ({ key, items }))
}

/** "Sun 18 Oct, 8:00 am" in the business's timezone. */
export function plainTime(iso: string, timeZone: string): string {
  const date = new Date(iso)
  let zone = timeZone
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: zone })
  } catch {
    zone = 'UTC'
  }
  const day = new Intl.DateTimeFormat('en-GB', {
    timeZone: zone,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  }).format(date)
  const time = new Intl.DateTimeFormat('en-US', {
    timeZone: zone,
    hour: 'numeric',
    minute: '2-digit',
  })
    .format(date)
    .replace(/\s*AM$/, ' am')
    .replace(/\s*PM$/, ' pm')
  return `${day.replace(/,/g, '')}, ${time}`
}

/** Who asked: the agent role, person's key or app the card names. */
export function callerName(approval: AgentApprovalResponse): string | null {
  return (approval.action_data?.api_key_name as string) || null
}
